import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";

import { FeedbackPage } from "@/presentation/components/requests/feedback-page";

const searchSchema = z.object({ id: z.string().optional() });

export const Route = createFileRoute("/_app/feedback/")({
  validateSearch: searchSchema,
  component: RequestsPage,
});

function RequestsPage() {
  const navigate = useNavigate({ from: Route.fullPath });
  const { id } = Route.useSearch();
  return (
    <FeedbackPage
      eyebrow="Implementation"
      openId={id ?? null}
      onOpen={(next) => navigate({ search: { id: next } })}
      onClose={() => navigate({ search: {} })}
    />
  );
}
